var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.06V18.682C6 19.4184 6.59695 20.0153 7.33333 20.0153H14L19.4683 20.0642C19.8097 20.0673 20.1369 20.2012 20.3825 20.4383L22 22V9.33333C22 8.59695 21.403 8 20.6667 8H19V13.682C19 14.4184 18.403 15.0153 17.6667 15.0153H11L6 15.06Z",
    fill: "#B35F9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 2C2.59695 2 2 2.59695 2 3.33333V16L3.61749 14.4383C3.86309 14.2012 4.1903 14.0673 4.53169 14.0642L10 14.0153H16.6667C17.403 14.0153 18 13.4184 18 12.682V3.33333C18 2.59695 17.403 2 16.6667 2H3.33333ZM9.78762 10.4135C9.84401 10.4691 9.9202 10.5 9.99998 10.5C10.0798 10.5 10.1559 10.4691 10.2123 10.4138L12.5423 8.12529C13.1526 7.52529 13.1526 6.54912 12.542 5.94912C12.2471 5.65971 11.8533 5.5 11.4337 5.5C11.0141 5.5 10.6203 5.65971 10.3251 5.94941L9.99998 6.26882L9.67455 5.94912C9.37971 5.65971 8.98589 5.5 8.56628 5.5C8.14666 5.5 7.75284 5.65971 7.458 5.94912C6.84733 6.54912 6.84733 7.52529 7.458 8.12529L9.78762 10.4135Z",
    fill: "#7CB141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForum);
export default __webpack_public_path__ + "static/media/Forum.41df8166805a1a3251d121935fb868b0.svg";
export { ForwardRef as ReactComponent };